// Fullscreen state store — not persisted (resets on page reload)
import { create } from 'zustand'

type FullscreenState = {
    isFullscreen: boolean
    hasToolbarToggle: boolean
}

type FullscreenAction = {
    setFullscreen: (value: boolean) => void
    toggleFullscreen: () => void
    setHasToolbarToggle: (value: boolean) => void
}

export const useFullscreenStore = create<FullscreenState & FullscreenAction>()(
    (set) => ({
        isFullscreen: false,
        hasToolbarToggle: false,
        setFullscreen: (value) => set(() => ({ isFullscreen: value })),
        toggleFullscreen: () =>
            set((state) => ({ isFullscreen: !state.isFullscreen })),
        setHasToolbarToggle: (value) =>
            set(() => ({ hasToolbarToggle: value })),
    }),
)
